import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Row, Col, Card } from "react-bootstrap"
import { getTokenMultiListAction } from "../../../../store/actions/TokenMultiSystemAction"
import { groupPatientsByDoctor } from "../../../../services/TokenmultiSystemService"
import Loader from "../../Common/Loader"
import logo from "../../../../../src/assets/images/logo.png"
import defaultAvatar from "../../../../../src/assets/images/placeholder.jpg"
import connect from "../../../../../src/assets/images/social-media_12891222.png"
export default function TokenSystemMulti() {
  const dispatch = useDispatch()
  const [lastUpdated, setLastUpdated] = useState(null)

  const patientList = useSelector((state) => state.tokenMultiSystem?.tokenMultiList || [])
  const [doctorsData, setDoctorsData] = useState([])
  const [loading, setLoading] = useState(true)

  // Effect to fetch data periodically
  useEffect(() => {
    // Load once with loader
    const fetchInitialData = async () => {
      setLoading(true)
      await dispatch(getTokenMultiListAction("Yes"))
      setLoading(false)
    }
  
    // Interval fetch without loader
    const fetchIntervalData = async () => {
      await dispatch(getTokenMultiListAction("Yes"))
    }
  
    fetchInitialData()
    const interval = setInterval(fetchIntervalData, 20000)
    return () => clearInterval(interval)
  }, [dispatch])
  
  useEffect(() => {
    if (patientList && patientList.length > 0) {
      const grouped = groupPatientsByDoctor(patientList)
      setDoctorsData(grouped)
      setLastUpdated(new Date())
    } else {
      setDoctorsData([])
    }
    setLoading(false)
  }, [patientList])

  const getDefaultAvatar = (patient) => {
    if (patient.patient_photo && patient.patient_photo !== "") {
      try {
        // Fix duplicated URL issue
        if (patient.patient_photo.includes('https://opdcrm.csnsindia.com/public/uploads/') && 
            patient.patient_photo.split('https://opdcrm.csnsindia.com/public/uploads/').length > 2) {
          
          // Extract the filename from the end of the URL
          const urlParts = patient.patient_photo.split('/');
          const filename = urlParts[urlParts.length - 1];
          
          // Get the folder name (like MjUw) from the URL
          const folderMatch = patient.patient_photo.match(/\/uploads\/([^\/]+)\//);
          const folder = folderMatch ? folderMatch[1] : 'MjUw';
          
          // Construct clean URL
          return `https://opdcrm.csnsindia.com/public/uploads/${folder}/${filename}`;
        }
        
        // Check for the specific pattern in your data
        if (patient.patient_photo.includes('https://opdcrm.csnsindia.com/public/uploads/MjUw/https://')) {
          const match = patient.patient_photo.match(/https:\/\/opdcrm\.csnsindia\.com\/public\/uploads\/[^\/]+\/(.+)$/);
          if (match && match[1]) {
            // Extract the folder name (MjUw) from the original URL
            const folderMatch = patient.patient_photo.match(/\/uploads\/([^\/]+)\//);
            const folder = folderMatch ? folderMatch[1] : 'MjUw';
            return `https://opdcrm.csnsindia.com/public/uploads/${folder}/${match[1]}`;
          }
        }
        
        return patient.patient_photo;
      } catch (error) {
        console.error('Error parsing avatar URL:', error);
        return patient.patient_photo;
      }
    }
    return defaultAvatar;
  }

  if (loading) {
    return (
      <div className="min-h-screen flex justify-center items-center">
        <Loader className="h-12 w-12 animate-spin" />
      </div>
    )
  }

  if (!doctorsData || doctorsData.length === 0) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{
          minHeight: "100vh",
          backgroundColor: "#f4f6f9",
          display: "flex",
        }}
      >
        <Card
          style={{
            width: "100%",
            maxWidth: "400px",
            padding: "20px",
            textAlign: "center",
            boxShadow: "0 6px 12px rgba(0, 0, 0, 0.05)",
            borderRadius: "16px",
            backgroundColor: "#ffffff",
          }}
        >
          <Card.Body>
            <h4 className="text-xl font-semibold text-gray-600">No patients in queue</h4>
            <p className="text-gray-500 mt-2">Please check back later or refresh the page.</p>
          </Card.Body>
        </Card>
      </div>
    );
  }

  return (
    <div
      style={{
        padding: "20px",
        backgroundColor: "#f4f6f9",
        minHeight: "100vh",
        overflow: "auto",
      }}
    >
      {/* Centered Logo for all screen sizes */}
      <div className="d-flex justify-content-center align-items-center mb-4">
        <img
          src={logo || "/placeholder.svg"}
          alt="Logo"
          className="img-fluid"
          style={{ maxWidth: "200px", height: "auto" }}
        />
      </div>
      {/* Patient cards */}
      <Row className="g-4 justify-content-center">
        {doctorsData.map((doctor) => (
          <Col key={doctor.doctor_id} xs={12} sm={10} md={6} lg={4} xl={3}>
            <Card
              style={{
                height: "800px",
                boxShadow: "0 6px 12px rgba(0, 0, 0, 0.05)",
                borderRadius: "16px",
                position: "relative",
              }}
            >
              {/* Per-doctor pause overlay */}
              {doctor.is_pause === "Yes" && (
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(0, 0, 0, 0.6)",
                    zIndex: 10,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "#fff",
                    fontSize: "1.5rem",
                    fontWeight: "bold",
                    textAlign: "center",
                    borderRadius: "16px",
                    padding: "1rem",
                  }}
                >
                  ⏸️ Paused<br />
                  The patient queue is currently paused.<br />
                  Please wait — it will resume shortly...
                </div>
              )}

              <Card.Body
                style={{
                  display: "flex",
                  flexDirection: "column",
                  padding: "20px",
                }}
              >
                <div style={{ marginBottom: "15px" }}>
                  <h5>OPD No -  {doctor.doctor_name}</h5>
                </div>

                {/* Current Patient Section */}
                {doctor.currentPatient ? (
  <div
    style={{
      background: "#eafaf1",
      padding: "15px",
      borderRadius: "12px",
      marginBottom: "15px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      border: "1px solid #d1e7dd",
    }}
  >
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "15px",
      }}
    >
      <img
        src={getDefaultAvatar(doctor.currentPatient)}
        alt="avatar"
        className="rounded-circle"
        style={{
          width: "60px",
          height: "60px",
          objectFit: "cover",
          border: "2px solid #fff",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        }}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = defaultAvatar;
        }}
      />

      <div>
        <small style={{ color: "#6c757d" }}>Current Patient</small>

        <h6
          style={{
            margin: 0,
            fontWeight: 600,
            color: "#007b5e",
            display: "flex",
            alignItems: "center",
            gap: "6px",
            flexWrap: "wrap",
          }}
        >
          {/* ✅ First Name + Last Initial */}
          {doctor.currentPatient.first_name}{" "}
          {doctor.currentPatient.last_name
            ? doctor.currentPatient.last_name.charAt(0).toUpperCase() + "."
            : ""}

          {/* ✅ Partner */}
          {doctor.currentPatient.partner_name && (
            <span
              style={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
                fontSize: "14px",
                fontWeight: 500,
              }}
            >
              <img
                src={connect}
                alt="Partner"
                width="16"
                height="16"
                style={{ cursor: "pointer" }}
                title={`Call ${doctor.currentPatient.partner_name}`}
                onClick={() => {
                  if (doctor.currentPatient?.partner_phone) {
                    window.location.href = `tel:${doctor.currentPatient.partner_phone}`;
                  }
                }}
              />
              {doctor.currentPatient.partner_name}
            </span>
          )}
        </h6>
      </div>
    </div>
  </div>
) : (
  <div
    style={{
      padding: "15px",
      background: "#f8f9fa",
      textAlign: "center",
      borderRadius: "10px",
      border: "1px dashed #ced4da",
      marginBottom: "15px",
    }}
  >
    <small style={{ color: "#6c757d" }}>No current patient</small>
  </div>
)}

                {/* Next Patient Section */}
                <h6
                  style={{
                    fontWeight: 600,
                    color: "#002b80",
                    marginBottom: "10px",
                  }}
                >
                  Next Patient
                </h6>
                
                <div
  style={{
    flex: 1,
    maxHeight: "200px",
    overflowY: "auto",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    marginBottom: "15px",
  }}
>
  {doctor.nextPatient ? (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
        background: "linear-gradient(135deg, #e3f2fd, #f8fbff)",
        padding: "12px",
        borderRadius: "14px",
        border: "1px solid #d6e4ff",
        boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
        transition: "0.2s",
      }}
    >
      {/* Avatar */}
      <img
        src={getDefaultAvatar(doctor.nextPatient)}
        alt="avatar"
        className="rounded-circle"
        style={{
          width: "50px",
          height: "50px",
          objectFit: "cover",
          border: "2px solid #fff",
          boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
        }}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = defaultAvatar;
        }}
      />

      {/* Info */}
      <div style={{ flex: 1 }}>
        {/* Name + Partner */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "6px",
            fontWeight: 600,
            fontSize: "15px",
          }}
        >
          {doctor.nextPatient.first_name}{" "}
          {doctor.nextPatient.last_name || ""}

          {/* Partner */}
          {doctor.nextPatient.partner_name && (
            <span
              style={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
                fontSize: "15px",
                
              }}
            >
              🔗 {doctor.nextPatient.partner_name}
            </span>
          )}
        </div>

        {/* Time */}
        <div
          style={{
            fontSize: "12px",
            color: "#6c757d",
            marginTop: "2px",
          }}
        >
           {doctor.nextPatient.time_slot}
        </div>

        {/* Status Row */}
        <div
          style={{
            display: "flex",
            gap: "6px",
            marginTop: "6px",
            flexWrap: "wrap",
          }}
        >
          {/* Status */}
     

          {/* Not Presented */}
          {doctor.nextPatient.is_presented === "No" && (
            <span className="badge bg-warning text-dark">
              Not Presented
            </span>
          )}
        </div>
      </div>
    </div>
  ) : (
    <div
      style={{
        textAlign: "center",
        color: "#adb5bd",
        padding: "15px",
        background: "#f8f9fa",
        borderRadius: "10px",
        border: "1px dashed #ced4da",
      }}
    >
      No next patient
    </div>
  )}
</div>

                {/* ========== UPCOMING PATIENTS SECTION - COMMENTED OUT ========== */}
                {/*
                <h6
                  style={{
                    fontWeight: 600,
                    color: "#002b80",
                    marginBottom: "10px",
                  }}
                >
                  Upcoming Patients
                </h6>
                <div
                  style={{
                    flex: 1,
                    maxHeight: "420px",
                    overflowY: "auto",
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                  }}
                >
                  {doctor.queue.length === 0 ? (
                    <div
                      style={{
                        textAlign: "center",
                        color: "#adb5bd",
                      }}
                    >
                      No patients in queue
                    </div>
                  ) : (
                    doctor.queue
                      .filter(patient => 
                        patient.patient_id !== doctor.currentPatient?.patient_id && 
                        patient.patient_id !== doctor.nextPatient?.patient_id
                      )
                      .slice(0, 5)
                      .map((patient, index) => (
                        <div
                          key={patient.patient_id}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            background: index % 2 === 0 ? "#f1f9ff" : "#fffdf5",
                            padding: "10px 15px",
                            borderRadius: "10px",
                            border: "1px solid #dee2e6",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                            }}
                          >
                            <img
                              src={getDefaultAvatar(patient)}
                              alt="avatar"
                              className="rounded-circle"
                              style={{
                                width: "45px",
                                height: "45px",
                                objectFit: "cover",
                                border: "1px solid #ddd",
                              }}
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = defaultAvatar;
                              }}
                            />
                            <div>
                              <p
                                style={{
                                  margin: 0,
                                  fontSize: "1rem",
                                  fontWeight: 500,
                                }}
                              >
                                {patient.first_name} {patient.last_name || ''}
                              </p>
                              <small
                                style={{
                                  color: "#6c757d",
                                  fontWeight: 600,
                                }}
                              >
                                {patient.time_slot}
                              </small>
                            </div>
                          </div>
                        </div>
                      ))
                  )}
                </div>
                */}
                {/* ========== END OF COMMENTED OUT SECTION ========== */}
                
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  )
}